export default __webpack_public_path__ + "static/media/goodreads3.01e1ac42.png";